// @flow

import * as React from "react";

import { Page, Grid, Card, Form, BlogCard } from "tabler-react";
import SiteWrapper from "../SiteWrapper.react";

function BlogPage(): React.Node {
  return (
    <SiteWrapper>
      <Page.Content title="Request a Test">
        <Grid.Row cards deck>
          <Grid.Col sm={12} xl={12}>
            <Card
              statusColor="blue"
              title="Information"
              body={`This will be the only page that's visable to non-authenticated users, which include
  residents looking to request a test`}
            />
            <Card
              statusColor="red"
              title="Call 911 or go to the emergency if you're experiencing any of the following"
            >
              <Grid.Row cards deck>
                <Grid.Col md={3}>
                  <Card
                    title="Severe difficulty breathing"
                    body="
(struggling for each breath, can only speak in single words)"
                  />
                </Grid.Col>
                <Grid.Col md={3}>
                  <Card
                    title="Severe chest pain"
                    body={`(constant tightness or crushing sensation)`}
                  />
                </Grid.Col>
                <Grid.Col md={3}>
                  <Card
                    title="Feeling confused"
                    body="(for example, unsure of where you are)"
                  />
                </Grid.Col>
                <Grid.Col md={3}>
                  <Card
                    title="Losing consciousness"
                    body="
(for example, fainting)"
                  />
                </Grid.Col>
              </Grid.Row>
            </Card>
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Card title="Self Assesment">
            <Card.Body>
              <p>Please check all that apply.</p>
              <Form.Group>
                <Form.Checkbox
                  label="Fever"
                  name="example-radios"
                  value="Fever"
                />
                <Form.Checkbox
                  label="Chills"
                  name="example-radios"
                  value="Chills"
                />
                <Form.Checkbox
                  
                  label="Coughs"
                  name="example-radios"
                  value="Coughs"
                />
                <Form.Checkbox
                  
                  
                  label="Barking Cough"
                  name="example-radios2"
                  value="Barking Cough"
                />
                <Form.Checkbox
                  
                  
                  label="Headache"
                  name="example-radios2"
                  value="Headache"
                />
                <Form.Checkbox
                  
                  
                  label="Runny Nose"
                  name="example-radios2"
                  value="Runny Nose"
                />
                <Form.Checkbox
                  
                  
                  label="Loss of smell or taste"
                  name="example-radios2"
                  value="Loss of smell or taste"
                />
                <Form.Checkbox
                  
                  
                  label="Fatigue"
                  name="example-radios2"
                  value="Fatigue"
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Grid.Row>
      </Page.Content>
    </SiteWrapper>
  );
}

export default BlogPage;
